import request from '@/config/axios'

export interface AgentDashboardSoftwareProfit {
  softwareId?: string
  softwareName?: string
  amount?: number
}

export interface AgentDashboardRecentSettle {
  id?: number
  settlementNo?: string
  agentId?: number
  agentName?: string
  period?: string
  totalAmount?: number
  status?: number
  createTime?: string
}

export interface AgentDashboardSummaryVO {
  normalCount?: number
  level1NormalCount?: number
  level2Count?: number
  pendingApplyCount?: number
  monthNewCount?: number
  boundMerchantCount?: number
  totalMerchantCount?: number
  unassignedMerchantCount?: number
  monthProfit?: number
  unsettledLedgerCount?: number
  pendingPaySettleCount?: number
  paidSettleAmount?: number
  paidSettleCount?: number
  currentPeriod?: string
  softwareProfits?: AgentDashboardSoftwareProfit[]
  recentSettles?: AgentDashboardRecentSettle[]
}

export interface AgentOperateLogVO {
  id?: number
  bizType?: string
  bizId?: number
  action?: string
  content?: string
  operatorId?: number
  operatorName?: string
  createTime?: string
}

export const getDashboardSummary = () =>
  request.get<AgentDashboardSummaryVO>({ url: '/agent/dashboard/summary' })

export const getDashboardRecentLogs = () =>
  request.get<AgentOperateLogVO[]>({ url: '/agent/dashboard/recent-logs' })
